export default __webpack_public_path__ + "static/vn-5f46823853315bf96c0797ee6600036b.svg";